export const getAccessToken = () => {
  if (typeof window === "undefined") {
    return null
  }
  const token = localStorage.getItem("okta-anonymous-access-token")
  if (token) {
    return { token }
  }
}

export const getRequiredSpecification = (
  attr = [],
  toMatch = "",
  matchIndex = 0,
  fetchIndex = 0
) => {
  return attr
    .map(s => s.split("|"))
    .find(parts => parts[matchIndex] === toMatch)?.[fetchIndex]
}

export const getRequiredPrice = (
  attr = [],
  toMatch = "",
  matchIndex = 0,
  fetchIndex = 0
) => {
  return attr
    .map(s => s.split("|"))
    .find(parts => parts[matchIndex] === toMatch)?.[fetchIndex]
}

export const MAP_LABELS = {
  id: {
    centerName: "Kohler Experience Center:",
    showroomName: "KOHLER Showroom",
    dearName: "Authorized KOHLER dealer",
    storelocatorButtonLabel: "Search",
    searchLabel: "LOKASI PENJUALAN",
  },
  en: {
    centerName: "Kohler Experience Center:",
    showroomName: "KOHLER Showroom",
    dearName: "Authorized KOHLER dealer",
    storelocatorButtonLabel: "Search",
    searchLabel: "Find a store",
  },
}

export const getLinkTarget = url => {
  const isExternal = url?.startsWith("http")

  return isExternal ? "_blank" : "_self"
}

export const getLinkTargetTab = tabinfo => {
  return tabinfo == "New Tab" ? "_blank" : "_self"
}
